import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M4.3 4.285a6 6 0 0 1 8.4 0 4 4 0 0 0 5.6 0A1 1 0 0 1 20 5v9c0 .269-.108.527-.3.715a6 6 0 0 1-8.4 0 4 4 0 0 0-5.3-.266V21a1 1 0 1 1-2 0V5a1 1 0 0 1 .072-.374 1 1 0 0 1 .228-.34"
      }
    )
  }
);
export {
  r as default
};
